module.exports = __webpack_public_path__ + "img/slider4.bdd07f0d.jpg";